<div class="column" [class.column-sm]="column.static">
  <div [class.text-muted]="!column.content" [innerHTML]="column.content || '-' | safeHtml"></div>
</div>
